import { CALL_INTAKE_API } from 'middleware/intakeApi';

import {
  DELETE_CALENDAR_FAILURE,
  DELETE_CALENDAR_REQUEST,
  DELETE_CALENDAR_SUCCESS,
  DELETE_CLIENT_CONTACT_FAILURE,
  DELETE_CLIENT_CONTACT_REQUEST,
  DELETE_CLIENT_CONTACT_SUCCESS,
  DELETE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE,
  DELETE_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
  DELETE_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
  DELETE_CLIENT_CONTRACT_FEE_FAILURE,
  DELETE_CLIENT_CONTRACT_FEE_REQUEST,
  DELETE_CLIENT_CONTRACT_FEE_SUCCESS,
  DELETE_CLIENT_CONTRACT_SLA_FAILURE,
  DELETE_CLIENT_CONTRACT_SLA_REQUEST,
  DELETE_CLIENT_CONTRACT_SLA_SUCCESS,
  DELETE_CLIENT_GENERAL_NOTES_FAILURE,
  DELETE_CLIENT_GENERAL_NOTES_REQUEST,
  DELETE_CLIENT_GENERAL_NOTES_SUCCESS,
  DELETE_CLIENT_ISSUES_CHALLENGES_FAILURE,
  DELETE_CLIENT_ISSUES_CHALLENGES_REQUEST,
  DELETE_CLIENT_ISSUES_CHALLENGES_SUCCESS,
  DELETE_CLIENT_POLICIES_IMPORTANT_NOTES_FAILURE,
  DELETE_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
  DELETE_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
  DELETE_CLIENT_POLICY_NOTES_FAILURE,
  DELETE_CLIENT_POLICY_NOTES_REQUEST,
  DELETE_CLIENT_POLICY_NOTES_SUCCESS,
  DELETE_CLIENT_SPECIAL_PROCESS_FAILURE,
  DELETE_CLIENT_SPECIAL_PROCESS_REQUEST,
  DELETE_CLIENT_SPECIAL_PROCESS_SUCCESS,
  DELETE_HOMESALE_CLOSING_COSTS_FAILURE,
  DELETE_HOMESALE_CLOSING_COSTS_REQUEST,
  DELETE_HOMESALE_CLOSING_COSTS_SUCCESS,
  DELETE_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE,
  DELETE_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
  DELETE_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
  DELETE_HOMESALE_GBO_INSPECTIONS_FAILURE,
  DELETE_HOMESALE_GBO_INSPECTIONS_REQUEST,
  DELETE_HOMESALE_GBO_INSPECTIONS_SUCCESS,
  DELETE_HOMESALE_HHG_PROCESS_FAILURE,
  DELETE_HOMESALE_HHG_PROCESS_REQUEST,
  DELETE_HOMESALE_HHG_PROCESS_SUCCESS,
  GET_CALENDAR_PERIODS_FAILURE,
  GET_CALENDAR_PERIODS_REQUEST,
  GET_CALENDAR_PERIODS_SUCCESS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_CLIENT_CALENDARS_FAILURE,
  GET_CLIENT_CALENDARS_REQUEST,
  GET_CLIENT_CALENDARS_SUCCESS,
  GET_CLIENT_COMMENTS_REQUEST,
  GET_CLIENT_CONTACTS_FAILURE,
  GET_CLIENT_CONTACTS_REQUEST,
  GET_CLIENT_CONTACTS_SUCCESS,
  GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE,
  GET_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
  GET_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
  GET_CLIENT_CONTRACT_FAILURE,
  GET_PREBUILT_TRIGGERS_SUCCESS,
  GET_PREBUILT_TRIGGERS_FAILURE,
  GET_PREBUILT_TRIGGERS_REQUEST,
  GET_CLIENT_CONTRACT_FEE_FAILURE,
  GET_CLIENT_CONTRACT_FEE_REQUEST,
  GET_CLIENT_CONTRACT_FEE_SUCCESS,
  GET_CLIENT_CONTRACT_REQUEST,
  GET_CLIENT_CONTRACT_SLA_FAILURE,
  GET_CLIENT_CONTRACT_SLA_REQUEST,
  GET_CLIENT_CONTRACT_SLA_SUCCESS,
  GET_CLIENT_CONTRACT_SUCCESS,
  GET_CLIENT_DETAILS_FAILURE,
  GET_CLIENT_DETAILS_REQUEST,
  GET_CLIENT_DETAILS_SUCCESS,
  GET_CLIENT_GENERAL_NOTES_FAILURE,
  GET_CLIENT_GENERAL_NOTES_REQUEST,
  GET_CLIENT_GENERAL_NOTES_SUCCESS,
  GET_CLIENT_HOMESALE_INFO_FAILURE,
  GET_CLIENT_HOMESALE_INFO_REQUEST,
  GET_CLIENT_HOMESALE_INFO_SUCCESS,
  GET_CLIENT_ISSUES_CHALLENGES_FAILURE,
  GET_CLIENT_ISSUES_CHALLENGES_REQUEST,
  GET_CLIENT_ISSUES_CHALLENGES_SUCCESS,
  GET_CLIENT_LUMP_SUM_FAILURE,
  GET_CLIENT_LUMP_SUM_REQUEST,
  GET_CLIENT_LUMP_SUM_SUCCESS,
  GET_CLIENT_METADATA_FAILURE,
  GET_CLIENT_METADATA_REQUEST,
  GET_CLIENT_METADATA_SUCCESS,
  GET_CLIENT_POLICIES_IMPORTANT_NOTES_FAILURE,
  GET_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
  GET_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
  GET_CLIENT_POLICY_NOTES_FAILURE,
  GET_CLIENT_POLICY_NOTES_REQUEST,
  GET_CLIENT_POLICY_NOTES_SUCCESS,
  GET_CLIENT_PREFERRED_VENDORS_FAILURE,
  GET_CLIENT_PREFERRED_VENDORS_REQUEST,
  GET_CLIENT_PREFERRED_VENDORS_SUCCESS,
  GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_FAILURE,
  GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_REQUEST,
  GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_SUCCESS,
  GET_CLIENT_SPECIAL_PROCESS_FAILURE,
  GET_CLIENT_SPECIAL_PROCESS_REQUEST,
  GET_CLIENT_SPECIAL_PROCESS_SUCCESS,
  GET_HOMESALE_CLOSING_COSTS_FAILURE,
  GET_HOMESALE_CLOSING_COSTS_REQUEST,
  GET_HOMESALE_CLOSING_COSTS_SUCCESS,
  GET_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE,
  GET_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
  GET_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
  GET_HOMESALE_GBO_INSPECTIONS_FAILURE,
  GET_HOMESALE_GBO_INSPECTIONS_REQUEST,
  GET_HOMESALE_GBO_INSPECTIONS_SUCCESS,
  GET_HOMESALE_HHG_PROCESS_FAILURE,
  GET_HOMESALE_HHG_PROCESS_REQUEST,
  GET_HOMESALE_HHG_PROCESS_SUCCESS,
  GET_INTERNAL_USERS_FAILURE,
  GET_INTERNAL_USERS_REQUEST,
  GET_INTERNAL_USERS_SUCCESS,
  GET_POLICIES_GENERAL_INFO_REQUEST,
  GET_POLICIES_GENERAL_INFO__FAILURE,
  GET_POLICIES_GENERAL_INFO__SUCCESS,
  POST_CLIENT_CALENDAR_FAILURE,
  POST_CLIENT_CALENDAR_REQUEST,
  POST_CLIENT_CALENDAR_SUCCESS,
  POST_CLIENT_CONTACT_FAILURE,
  POST_CLIENT_CONTACT_REQUEST,
  POST_CLIENT_CONTACT_SUCCESS,
  POST_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE,
  POST_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
  POST_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
  POST_CLIENT_CONTRACT_FEE_FAILURE,
  POST_CLIENT_CONTRACT_FEE_REQUEST,
  POST_CLIENT_CONTRACT_FEE_SUCCESS,
  POST_CLIENT_CONTRACT_SLA_FAILURE,
  POST_CLIENT_CONTRACT_SLA_REQUEST,
  POST_CLIENT_CONTRACT_SLA_SUCCESS,
  POST_CLIENT_GENERAL_NOTES_FAILURE,
  POST_CLIENT_GENERAL_NOTES_REQUEST,
  POST_CLIENT_GENERAL_NOTES_SUCCESS,
  POST_CLIENT_ISSUES_CHALLENGES_FAILURE,
  POST_CLIENT_ISSUES_CHALLENGES_REQUEST,
  POST_CLIENT_ISSUES_CHALLENGES_SUCCESS,
  POST_CLIENT_POLICY_NOTES_FAILURE,
  POST_CLIENT_POLICY_NOTES_REQUEST,
  POST_CLIENT_POLICY_NOTES_SUCCESS,
  POST_GBO_INSPECTIONS_INITIALIZE_FAILURE,
  POST_GBO_INSPECTIONS_INITIALIZE_REQUEST,
  POST_GBO_INSPECTIONS_INITIALIZE_SUCCESS,
  POST_HOMESALE_CLOSING_COSTS_FAILURE,
  POST_HOMESALE_CLOSING_COSTS_REQUEST,
  POST_HOMESALE_CLOSING_COSTS_SUCCESS,
  POST_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE,
  POST_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
  POST_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
  POST_HOMESALE_GBO_INSPECTIONS_FAILURE,
  POST_HOMESALE_GBO_INSPECTIONS_REQUEST,
  POST_HOMESALE_GBO_INSPECTIONS_SUCCESS,
  POST_HOMESALE_HHG_PROCESS_FAILURE,
  POST_HOMESALE_HHG_PROCESS_REQUEST,
  POST_HOMESALE_HHG_PROCESS_SUCCESS,
  SET_CURRENT_CLIENT_ID,
  SET_LOADING_COMPLETE,
  UPDATE_CLIENT_CALENDAR_FAILURE,
  UPDATE_CLIENT_CALENDAR_REQUEST,
  UPDATE_CLIENT_CALENDAR_SUCCESS,
  UPDATE_CLIENT_CONTACT_FAILURE,
  UPDATE_CLIENT_CONTACT_REQUEST,
  UPDATE_CLIENT_CONTACT_SUCCESS,
  UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE,
  UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
  UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
  UPDATE_CLIENT_CONTRACT_FEE_FAILURE,
  UPDATE_CLIENT_CONTRACT_FEE_REQUEST,
  UPDATE_CLIENT_CONTRACT_FEE_SUCCESS,
  UPDATE_CLIENT_CONTRACT_SLA_FAILURE,
  UPDATE_CLIENT_CONTRACT_SLA_REQUEST,
  UPDATE_CLIENT_CONTRACT_SLA_SUCCESS,
  UPDATE_CLIENT_GENERAL_NOTES_FAILURE,
  UPDATE_CLIENT_GENERAL_NOTES_REQUEST,
  UPDATE_CLIENT_GENERAL_NOTES_SUCCESS,
  UPDATE_CLIENT_HOMESALE_INFO_FAILURE,
  UPDATE_CLIENT_HOMESALE_INFO_REQUEST,
  UPDATE_CLIENT_HOMESALE_INFO_SUCCESS,
  UPDATE_CLIENT_ISSUES_CHALLENGES_FAILURE,
  UPDATE_CLIENT_ISSUES_CHALLENGES_REQUEST,
  UPDATE_CLIENT_ISSUES_CHALLENGES_SUCCESS,
  UPDATE_CLIENT_LUMP_SUM_FAILURE,
  UPDATE_CLIENT_LUMP_SUM_REQUEST,
  UPDATE_CLIENT_LUMP_SUM_SUCCESS,
  UPDATE_CLIENT_POLICY_NOTES_FAILURE,
  UPDATE_CLIENT_POLICY_NOTES_REQUEST,
  UPDATE_CLIENT_POLICY_NOTES_SUCCESS,
  UPDATE_HOMESALE_CLOSING_COSTS_FAILURE,
  UPDATE_HOMESALE_CLOSING_COSTS_REQUEST,
  UPDATE_HOMESALE_CLOSING_COSTS_SUCCESS,
  UPDATE_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE,
  UPDATE_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
  UPDATE_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
  UPDATE_HOMESALE_GBO_INSPECTIONS_FAILURE,
  UPDATE_HOMESALE_GBO_INSPECTIONS_REQUEST,
  UPDATE_HOMESALE_GBO_INSPECTIONS_SUCCESS,
  UPDATE_HOMESALE_HHG_PROCESS_FAILURE,
  UPDATE_HOMESALE_HHG_PROCESS_REQUEST,
  UPDATE_HOMESALE_HHG_PROCESS_SUCCESS,
  UPDATE_PERIOD_FAILURE,
  UPDATE_PERIOD_REQUEST,
  UPDATE_PERIOD_SUCCESS,
  UPDATE_POLICIES_GENERAL_INFO__FAILURE,
  UPDATE_POLICIES_GENERAL_INFO__REQUEST,
  UPDATE_POLICIES_GENERAL_INFO__SUCCESS,
  UPSERT_CLIENT_POLICIES_IMPORTANT_NOTES_FAILURE,
  UPSERT_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
  UPSERT_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
  UPSERT_CLIENT_PREFERRED_VENDORS_FAILURE,
  UPSERT_CLIENT_PREFERRED_VENDORS_REQUEST,
  UPSERT_CLIENT_PREFERRED_VENDORS_SUCCESS,
  UPSERT_CLIENT_SPECIAL_PROCESS_FAILURE,
  UPSERT_CLIENT_SPECIAL_PROCESS_REQUEST,
  UPSERT_CLIENT_SPECIAL_PROCESS_SUCCESS
} from './types';

// Import rewired types

import {
  GET_ACTIVE_CLIENTS_FAILURE,
  GET_ACTIVE_CLIENTS_REQUEST,
  GET_ACTIVE_CLIENTS_SUCCESS,
  GET_ACTIVE_CLIENT_ADDRESSES_FAILURE,
  GET_ACTIVE_CLIENT_ADDRESSES_REQUEST,
  GET_ACTIVE_CLIENT_ADDRESSES_SUCCESS,
  GET_ACTIVE_CLIENT_BILLING_POLICIES_FAILURE,
  GET_ACTIVE_CLIENT_BILLING_POLICIES_REQUEST,
  GET_ACTIVE_CLIENT_BILLING_POLICIES_SUCCESS,
  GET_CLIENT_ADDRESSES_BY_CLIENT_ID_FAILURE,
  GET_CLIENT_ADDRESSES_BY_CLIENT_ID_REQUEST,
  GET_CLIENT_ADDRESSES_BY_CLIENT_ID_SUCCESS,
  GET_CLIENT_ADDRESSES_BY_ID_FAILURE,
  GET_CLIENT_ADDRESSES_BY_ID_REQUEST,
  GET_CLIENT_ADDRESSES_BY_ID_SUCCESS,
  GET_CLIENT_ADDRESSES_FAILURE,
  GET_CLIENT_ADDRESSES_REQUEST,
  GET_CLIENT_ADDRESSES_SUCCESS,
  GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE,
  GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_REQUEST,
  GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_SUCCESS,
  GET_CLIENT_RELO_POLICIES_BY_ID_FAILURE,
  GET_CLIENT_RELO_POLICIES_BY_ID_REQUEST,
  GET_CLIENT_RELO_POLICIES_BY_ID_SUCCESS,
  GET_CLIENT_RELO_POLICIES_FAILURE,
  GET_CLIENT_RELO_POLICIES_REQUEST,
  GET_CLIENT_RELO_POLICIES_SUCCESS,
  GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_FAILURE,
  GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_REQUEST,
  GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_SUCCESS,
  GET_CLIENT_BILLING_POLICIES_FAILURE,
  GET_CLIENT_BILLING_POLICIES_BY_ID_FAILURE,
  GET_CLIENT_BILLING_POLICIES_REQUEST,
  GET_CLIENT_BILLING_POLICIES_BY_ID_REQUEST,
  GET_CLIENT_BILLING_POLICIES_SUCCESS,
  GET_ACTIVE_CLIENT_RELO_POLICIES_FAILURE,
  GET_ACTIVE_CLIENT_RELO_POLICIES_SUCCESS,
  GET_ACTIVE_CLIENT_RELO_POLICIES_REQUEST,
  GET_CLIENT_BILLING_POLICIES_BY_ID_SUCCESS,
  POST_CLIENT_ADDRESS_FAILURE,
  POST_CLIENT_ADDRESS_REQUEST,
  POST_CLIENT_ADDRESS_SUCCESS,
  POST_CLIENT_BILLING_POLICY_FAILURE,
  POST_CLIENT_BILLING_POLICY_REQUEST,
  POST_CLIENT_BILLING_POLICY_SUCCESS,
  POST_CLIENT_RELO_POLICY_FAILURE,
  POST_CLIENT_RELO_POLICY_REQUEST,
  POST_CLIENT_RELO_POLICY_SUCCESS,
  POST_CLIENT_REQUEST,
  POST_CLIENT_SUCCESS,
  POST_CLIENT_FAILURE,
  UPDATE_CLIENT_ADDRESS_FAILURE,
  UPDATE_CLIENT_ADDRESS_REQUEST,
  UPDATE_CLIENT_ADDRESS_SUCCESS,
  UPDATE_CLIENT_BILLING_POLICY_FAILURE,
  UPDATE_CLIENT_BILLING_POLICY_REQUEST,
  UPDATE_CLIENT_BILLING_POLICY_SUCCESS,
  UPDATE_CLIENT_RELO_POLICY_FAILURE,
  UPDATE_CLIENT_RELO_POLICY_REQUEST,
  UPDATE_CLIENT_RELO_POLICY_SUCCESS,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAILURE,
  DELETE_CLIENT_ADDRESS_FAILURE,
  DELETE_CLIENT_ADDRESS_REQUEST,
  DELETE_CLIENT_ADDRESS_SUCCESS,
  DELETE_CLIENT_BILLING_POLICY_FAILURE,
  DELETE_CLIENT_BILLING_POLICY_REQUEST,
  DELETE_CLIENT_BILLING_POLICY_SUCCESS,
  DELETE_CLIENT_RELO_POLICY_FAILURE,
  DELETE_CLIENT_RELO_POLICY_REQUEST,
  DELETE_CLIENT_RELO_POLICY_SUCCESS,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  GET_CLIENT_DIVISIONS_FAILURE,
  GET_CLIENT_DIVISIONS_REQUEST,
  GET_CLIENT_DIVISIONS_SUCCESS,
  GET_CLIENT_DIVISION_BY_ID_FAILURE,
  GET_CLIENT_DIVISION_BY_ID_REQUEST,
  GET_CLIENT_DIVISION_BY_ID_SUCCESS,
  POST_CLIENT_DIVISION_FAILURE,
  POST_CLIENT_DIVISION_REQUEST,
  POST_CLIENT_DIVISION_SUCCESS,
  UPDATE_CLIENT_DIVISION_FAILURE,
  UPDATE_CLIENT_DIVISION_REQUEST,
  UPDATE_CLIENT_DIVISION_SUCCESS,
  DELETE_CLIENT_DIVISION_FAILURE,
  DELETE_CLIENT_DIVISION_REQUEST,
  DELETE_CLIENT_DIVISION_SUCCESS,
  GET_CLIENT_COMMENTS_FAILURE,
  GET_CLIENT_COMMENTS_SUCCESS,
  GET_CLIENT_COMMENT_BY_ID_FAILURE,
  GET_CLIENT_COMMENT_BY_ID_REQUEST,
  GET_CLIENT_COMMENT_BY_ID_SUCCESS,
  POST_CLIENT_COMMENT_FAILURE,
  POST_CLIENT_COMMENT_REQUEST,
  POST_CLIENT_COMMENT_SUCCESS,
  UPDATE_CLIENT_COMMENT_FAILURE,
  UPDATE_CLIENT_COMMENT_REQUEST,
  UPDATE_CLIENT_COMMENT_SUCCESS,
  DELETE_CLIENT_COMMENT_FAILURE,
  DELETE_CLIENT_COMMENT_REQUEST,
  DELETE_CLIENT_COMMENT_SUCCESS,
  POST_CLIENT_FEE_REQUEST,
  POST_CLIENT_FEE_SUCCESS,
  POST_CLIENT_FEE_FAILURE,
  UPDATE_CLIENT_FEE_REQUEST,
  UPDATE_CLIENT_FEE_SUCCESS,
  UPDATE_CLIENT_FEE_FAILURE,
  DELETE_CLIENT_FEE_REQUEST,
  DELETE_CLIENT_FEE_SUCCESS,
  DELETE_CLIENT_FEE_FAILURE,
  GET_CLIENT_STATIC_BENEFITS_REQUEST,
  GET_CLIENT_STATIC_BENEFITS_SUCCESS,
  GET_CLIENT_STATIC_BENEFITS_FAILURE,
  GET_CLIENT_CUSTOM_FIELDS_FAILURE,
  GET_CLIENT_CUSTOM_FIELDS_REQUEST,
  GET_CLIENT_CUSTOM_FIELDS_SUCCESS,
  GET_CLIENT_CUSTOM_FIELD_BY_ID_FAILURE,
  GET_CLIENT_CUSTOM_FIELD_BY_ID_REQUEST,
  GET_CLIENT_CUSTOM_FIELD_BY_ID_SUCCESS,
  POST_CLIENT_CUSTOM_FIELD_FAILURE,
  POST_CLIENT_CUSTOM_FIELD_REQUEST,
  POST_CLIENT_CUSTOM_FIELD_SUCCESS,
  POST_CLIENT_PURPOSE_BUILT_FIELD_FAILURE,
  POST_CLIENT_PURPOSE_BUILT_FIELD_REQUEST,
  POST_CLIENT_PURPOSE_BUILT_FIELD_SUCCESS,
  UPDATE_CLIENT_CUSTOM_FIELD_FAILURE,
  UPDATE_CLIENT_CUSTOM_FIELD_REQUEST,
  UPDATE_CLIENT_CUSTOM_FIELD_SUCCESS,
  DELETE_CLIENT_CUSTOM_FIELD_FAILURE,
  DELETE_CLIENT_CUSTOM_FIELD_REQUEST,
  DELETE_CLIENT_CUSTOM_FIELD_SUCCESS,
  DELETE_CLIENT_PURPOSE_BUILT_FIELD_FAILURE,
  DELETE_CLIENT_PURPOSE_BUILT_FIELD_REQUEST,
  DELETE_CLIENT_PURPOSE_BUILT_FIELD_SUCCESS,
  GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE,
  GET_PURPOSE_BUILT_FIELD_TEMPLATES_REQUEST,
  GET_PURPOSE_BUILT_FIELD_TEMPLATES_SUCCESS,
  GET_PURPOSE_BUILT_FIELD_TEMPLATE_BY_ID_FAILURE,
  GET_PURPOSE_BUILT_FIELD_TEMPLATE_BY_ID_REQUEST,
  GET_PURPOSE_BUILT_FIELD_TEMPLATE_BY_ID_SUCCESS,
  POST_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE,
  POST_PURPOSE_BUILT_FIELD_TEMPLATE_REQUEST,
  POST_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
  UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE,
  UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_REQUEST,
  UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
  DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE,
  DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_REQUEST,
  DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
  POST_CLIENT_COMMENTS_ATTACHMENT_FAILURE,
  POST_CLIENT_COMMENTS_ATTACHMENT_REQUEST,
  POST_CLIENT_COMMENTS_ATTACHMENT_SUCCESS,
  UPDATE_CLIENT_COMMENTS_ATTACHMENT_FAILURE,
  UPDATE_CLIENT_COMMENTS_ATTACHMENT_REQUEST,
  UPDATE_CLIENT_COMMENTS_ATTACHMENT_SUCCESS,
  DELETE_CLIENT_COMMENTS_ATTACHMENT_FAILURE,
  DELETE_CLIENT_COMMENTS_ATTACHMENT_REQUEST,
  DELETE_CLIENT_COMMENTS_ATTACHMENT_SUCCESS,
  GET_MULTI_CLIENT_USERS_REQUEST,
  GET_MULTI_CLIENT_USERS_SUCCESS,
  GET_MULTI_CLIENT_USERS_FAILURE,
  POST_MULTI_CLIENT_USER_REQUEST,
  POST_MULTI_CLIENT_USER_SUCCESS,
  POST_MULTI_CLIENT_USER_FAILURE,
  UPDATE_MULTI_CLIENT_USER_ACCESS_REQUEST,
  UPDATE_MULTI_CLIENT_USER_ACCESS_SUCCESS,
  UPDATE_MULTI_CLIENT_USER_ACCESS_FAILURE,
  DELETE_MULTI_CLIENT_USER_REQUEST,
  DELETE_MULTI_CLIENT_USER_SUCCESS,
  DELETE_MULTI_CLIENT_USER_FAILURE,
  GET_ACUMATICA_CLIENT_REQUEST_PREVIEW_REQUEST,
  GET_ACUMATICA_CLIENT_REQUEST_PREVIEW_SUCCESS,
  GET_ACUMATICA_CLIENT_REQUEST_PREVIEW_FAILURE,
  GET_ACUMATICA_PUSH_CLIENT_CHANGES_REQUEST,
  GET_ACUMATICA_PUSH_CLIENT_CHANGES_SUCCESS,
  GET_ACUMATICA_PUSH_CLIENT_CHANGES_FAILURE
} from './types';

import { SET_FOCUSED_TAB } from 'modules/intake/types';
import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const setClientFocusedTab = tab => ({
  type: SET_FOCUSED_TAB,
  response: tab
});

export const setClientId = id => ({
  type: SET_CURRENT_CLIENT_ID,
  response: id
});

// RE-WIRED CLIENT ENDPOINTS \\
// Added on: 7/17/2025 by Vanessa Osterberg \\

// ----- CLIENT RECORD ------ \\

export const getClients = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENTS_REQUEST, GET_CLIENTS_SUCCESS, GET_CLIENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/Client',
      method: 'GET'
    }
  };
};

export const getClientDetails = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_DETAILS_REQUEST, GET_CLIENT_DETAILS_SUCCESS, GET_CLIENT_DETAILS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${id}`,
      method: 'GET'
    }
  };
};

export const getActiveClients = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVE_CLIENTS_REQUEST, GET_ACTIVE_CLIENTS_SUCCESS, GET_ACTIVE_CLIENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/activeClients',
      method: 'GET'
    }
  };
};

export const postClient = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_REQUEST, POST_CLIENT_SUCCESS, POST_CLIENT_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client',
      method: 'POST'
    }
  };
};

export const updateClient = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client',
      method: 'PUT'
    }
  };
};

export const deleteClient = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_REQUEST, DELETE_CLIENT_SUCCESS, DELETE_CLIENT_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${id}`,
      method: 'DELETE'
    }
  };
};

// -------- CLIENT DIVISIONS ------- \\

export const getAllClientDivisions = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_DIVISIONS_REQUEST, GET_CLIENT_DIVISIONS_SUCCESS, GET_CLIENT_DIVISIONS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/divisions/${id}`,
      method: 'GET'
    }
  };
};

export const getClientDivisionById = clientDivisionId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_DIVISION_BY_ID_REQUEST, GET_CLIENT_DIVISION_BY_ID_SUCCESS, GET_CLIENT_DIVISION_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Client/divisions/getById/${clientDivisionId}`,
      method: 'GET'
    }
  };
};

export const postClientDivision = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_DIVISION_REQUEST, POST_CLIENT_DIVISION_SUCCESS, POST_CLIENT_DIVISION_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/divisions',
      method: 'POST'
    }
  };
};

export const updateClientDivision = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_DIVISION_REQUEST, UPDATE_CLIENT_DIVISION_SUCCESS, UPDATE_CLIENT_DIVISION_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/divisions',
      method: 'PUT'
    }
  };
};

export const deleteClientDivision = clientDivisionId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_DIVISION_REQUEST, DELETE_CLIENT_DIVISION_SUCCESS, DELETE_CLIENT_DIVISION_FAILURE],
      authenticated: true,
      endpoint: `api/Client/divisions/${clientDivisionId}`,
      method: 'DELETE'
    }
  };
};

// -------- CLIENT ADDRESSES ------- \\

export const getClientAddresses = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_ADDRESSES_REQUEST, GET_CLIENT_ADDRESSES_SUCCESS, GET_CLIENT_ADDRESSES_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/clientAddresses',
      method: 'GET'
    }
  };
};

export const getClientAddressesByClientId = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_CLIENT_ADDRESSES_BY_CLIENT_ID_REQUEST,
        GET_CLIENT_ADDRESSES_BY_CLIENT_ID_SUCCESS,
        GET_CLIENT_ADDRESSES_BY_CLIENT_ID_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/clientAddresses/getByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const getClientAddressesById = addressId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_ADDRESSES_BY_ID_REQUEST, GET_CLIENT_ADDRESSES_BY_ID_SUCCESS, GET_CLIENT_ADDRESSES_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Client/clientAddresses/getById/${addressId}`,
      method: 'GET'
    }
  };
};

export const getActiveClientAddresses = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVE_CLIENT_ADDRESSES_REQUEST, GET_ACTIVE_CLIENT_ADDRESSES_SUCCESS, GET_ACTIVE_CLIENT_ADDRESSES_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/activeClients',
      method: 'GET'
    }
  };
};

export const postClientAddress = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_ADDRESS_REQUEST, POST_CLIENT_ADDRESS_SUCCESS, POST_CLIENT_ADDRESS_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/clientAddresses',
      method: 'POST'
    }
  };
};

export const updateClientAddress = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_ADDRESS_REQUEST, UPDATE_CLIENT_ADDRESS_SUCCESS, UPDATE_CLIENT_ADDRESS_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/clientAddresses',
      method: 'PUT'
    }
  };
};

export const deleteClientAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_ADDRESS_REQUEST, DELETE_CLIENT_ADDRESS_SUCCESS, DELETE_CLIENT_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/clientAddresses/${id}`,
      method: 'DELETE'
    }
  };
};

// ----- RELOCATION POLICIES ----- \\

export const getClientStaticBenefits = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_STATIC_BENEFITS_REQUEST, GET_CLIENT_STATIC_BENEFITS_SUCCESS, GET_CLIENT_STATIC_BENEFITS_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/staticBenefits',
      method: 'GET'
    }
  };
};

export const getClientRelocationPolicies = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_RELO_POLICIES_REQUEST, GET_CLIENT_RELO_POLICIES_SUCCESS, GET_CLIENT_RELO_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/relocationPolicies',
      method: 'GET'
    }
  };
};

export const getClientRelocationPoliciesByClientId = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_REQUEST,
        GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_SUCCESS,
        GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/relocationPolicies/getByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const getClientRelocationPolicyById = reloPolicyId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_RELO_POLICIES_BY_ID_REQUEST, GET_CLIENT_RELO_POLICIES_BY_ID_SUCCESS, GET_CLIENT_RELO_POLICIES_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Client/relocationPolicies/getById/${reloPolicyId}`,
      method: 'GET'
    }
  };
};

export const getActiveClientRelocationPoliciesByClientId = clientId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVE_CLIENT_RELO_POLICIES_REQUEST, GET_ACTIVE_CLIENT_RELO_POLICIES_SUCCESS, GET_ACTIVE_CLIENT_RELO_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/Client/relocationPolicies/activePoliciesByClient/${clientId}`,
      method: 'GET'
    }
  };
};

export const postClientRelocationPolicy = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_RELO_POLICY_REQUEST, POST_CLIENT_RELO_POLICY_SUCCESS, POST_CLIENT_RELO_POLICY_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/relocationPolicies',
      method: 'POST'
    }
  };
};

export const updateClientRelocationPolicy = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_RELO_POLICY_REQUEST, UPDATE_CLIENT_RELO_POLICY_SUCCESS, UPDATE_CLIENT_RELO_POLICY_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/relocationPolicies',
      method: 'PUT'
    }
  };
};

export const deleteClientRelocationPolicy = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_RELO_POLICY_REQUEST, DELETE_CLIENT_RELO_POLICY_SUCCESS, DELETE_CLIENT_RELO_POLICY_FAILURE],
      authenticated: true,
      endpoint: `api/Client/relocationPolicies/${id}`,
      method: 'DELETE'
    }
  };
};

// ------ BILLING POLICIES ------ \\

export const getClientBillingPolicies = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_BILLING_POLICIES_REQUEST, GET_CLIENT_BILLING_POLICIES_SUCCESS, GET_CLIENT_BILLING_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/billingPolicies',
      method: 'GET'
    }
  };
};

export const getClientBillingPoliciesByClientId = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_REQUEST,
        GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_SUCCESS,
        GET_CLIENT_BILLING_POLICIES_BY_CLIENT_ID_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/billingPolicies/getByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const getClientBillingPolicyById = billingPolicyId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_CLIENT_BILLING_POLICIES_BY_ID_REQUEST,
        GET_CLIENT_BILLING_POLICIES_BY_ID_SUCCESS,
        GET_CLIENT_BILLING_POLICIES_BY_ID_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/billingPolicies/getById/${billingPolicyId}`,
      method: 'GET'
    }
  };
};

export const getActiveClientBillingPoliciesByClientId = clientId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ACTIVE_CLIENT_BILLING_POLICIES_REQUEST,
        GET_ACTIVE_CLIENT_BILLING_POLICIES_SUCCESS,
        GET_ACTIVE_CLIENT_BILLING_POLICIES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/billingPolicies/activePoliciesByClient/${clientId}`,
      method: 'GET'
    }
  };
};

export const postClientBillingPolicy = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_BILLING_POLICY_REQUEST, POST_CLIENT_BILLING_POLICY_SUCCESS, POST_CLIENT_BILLING_POLICY_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/billingPolicies',
      method: 'POST'
    }
  };
};

export const updateClientBillingPolicy = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_BILLING_POLICY_REQUEST, UPDATE_CLIENT_BILLING_POLICY_SUCCESS, UPDATE_CLIENT_BILLING_POLICY_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/billingPolicies',
      method: 'PUT'
    }
  };
};

export const deleteClientBillingPolicy = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_BILLING_POLICY_REQUEST, DELETE_CLIENT_BILLING_POLICY_SUCCESS, DELETE_CLIENT_BILLING_POLICY_FAILURE],
      authenticated: true,
      endpoint: `api/Client/billingPolicies/${id}`,
      method: 'DELETE'
    }
  };
};

// -------- CLIENT COMMENTS ------- \\

export const getAllClientComments = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_COMMENTS_REQUEST, GET_CLIENT_COMMENTS_SUCCESS, GET_CLIENT_COMMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${id}/clientComments`,
      method: 'GET'
    }
  };
};

export const getClientCommentById = clientCommentId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_COMMENT_BY_ID_REQUEST, GET_CLIENT_COMMENT_BY_ID_SUCCESS, GET_CLIENT_COMMENT_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Client/clientComments/getById/${clientCommentId}`,
      method: 'GET'
    }
  };
};

export const postClientComment = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_COMMENT_REQUEST, POST_CLIENT_COMMENT_SUCCESS, POST_CLIENT_COMMENT_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/clientComments',
      method: 'POST'
    }
  };
};

export const updateClientComment = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_COMMENT_REQUEST, UPDATE_CLIENT_COMMENT_SUCCESS, UPDATE_CLIENT_COMMENT_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/clientComments',
      method: 'PUT'
    }
  };
};

export const deleteClientComment = clientCommentId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_COMMENT_REQUEST, DELETE_CLIENT_COMMENT_SUCCESS, DELETE_CLIENT_COMMENT_FAILURE],
      authenticated: true,
      endpoint: `api/Client/clientComments/${clientCommentId}`,
      method: 'DELETE'
    }
  };
};

export const postClientCommentsAttachment = (attachment, clientRecordId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_COMMENTS_ATTACHMENT_REQUEST, POST_CLIENT_COMMENTS_ATTACHMENT_SUCCESS, POST_CLIENT_COMMENTS_ATTACHMENT_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${clientRecordId}/comments/${commentId}/attachments`,
      method: 'POST',
      payload: attachment,
      context: { commentId: commentId }
    }
  };
};

export const updateClientCommentsAttachment = (attachment, clientRecordId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_CLIENT_COMMENTS_ATTACHMENT_REQUEST,
        UPDATE_CLIENT_COMMENTS_ATTACHMENT_SUCCESS,
        UPDATE_CLIENT_COMMENTS_ATTACHMENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/${clientRecordId}/comments/${commentId}/attachments`,
      method: 'PUT',
      payload: attachment,
      context: { commentId: commentId }
    }
  };
};

export const deleteClientCommentsAttachment = (clientRecordId, commentId, attachmentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_CLIENT_COMMENTS_ATTACHMENT_REQUEST,
        DELETE_CLIENT_COMMENTS_ATTACHMENT_SUCCESS,
        DELETE_CLIENT_COMMENTS_ATTACHMENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/${clientRecordId}/comments/${commentId}/attachments/${attachmentId}`,
      method: 'DELETE',
      context: { commentId: commentId }
    }
  };
};

// ----- BILLING POLICY FEES ----- \\

export const getPrebuiltTriggers = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_PREBUILT_TRIGGERS_REQUEST, GET_PREBUILT_TRIGGERS_SUCCESS, GET_PREBUILT_TRIGGERS_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/fees/prebuiltTriggers/',
      method: 'GET'
    }
  };
};

export const postClientFee = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_FEE_REQUEST, POST_CLIENT_FEE_SUCCESS, POST_CLIENT_FEE_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/fees',
      method: 'POST'
    }
  };
};

export const updateClientFee = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_FEE_REQUEST, UPDATE_CLIENT_FEE_SUCCESS, UPDATE_CLIENT_FEE_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/fees',
      method: 'PUT'
    }
  };
};

export const deleteClientFee = (clientFeeId, clientBillingPolicyId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_FEE_REQUEST, DELETE_CLIENT_FEE_SUCCESS, DELETE_CLIENT_FEE_FAILURE],
      authenticated: true,
      endpoint: `api/Client/fees/${clientFeeId}?billingPolicyId=${clientBillingPolicyId}`,
      method: 'DELETE'
      // context: { clientBillingPolicyId: clientBillingPolicyId }
    }
  };
};

// -------- CLIENT CUSTOM FIELDS ------- \\

export const getClientCustomFields = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_CUSTOM_FIELDS_REQUEST, GET_CLIENT_CUSTOM_FIELDS_SUCCESS, GET_CLIENT_CUSTOM_FIELDS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/customFields/${id}`,
      method: 'GET'
    }
  };
};

export const getClientCustomFieldById = clientCustomFieldId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_CUSTOM_FIELD_BY_ID_REQUEST, GET_CLIENT_CUSTOM_FIELD_BY_ID_SUCCESS, GET_CLIENT_CUSTOM_FIELD_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Client/customFields/getById/${clientCustomFieldId}`,
      method: 'GET'
    }
  };
};

export const getAllPurposeBuiltFieldTemplates = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_PURPOSE_BUILT_FIELD_TEMPLATES_REQUEST,
        GET_PURPOSE_BUILT_FIELD_TEMPLATES_SUCCESS,
        GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/purposeBuiltFieldTemplate/`,
      method: 'GET'
    }
  };
};

export const getPurposeBuiltFieldTemplateById = purposeBuiltFieldTemplateId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_PURPOSE_BUILT_FIELD_TEMPLATE_BY_ID_REQUEST,
        GET_PURPOSE_BUILT_FIELD_TEMPLATE_BY_ID_SUCCESS,
        GET_PURPOSE_BUILT_FIELD_TEMPLATE_BY_ID_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/purposeBuiltFieldTemplate/getById/${purposeBuiltFieldTemplateId}`,
      method: 'GET'
    }
  };
};

export const postClientCustomField = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_CUSTOM_FIELD_REQUEST, POST_CLIENT_CUSTOM_FIELD_SUCCESS, POST_CLIENT_CUSTOM_FIELD_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/customFields',
      method: 'POST'
    }
  };
};

export const postPurposeBuiltField = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_PURPOSE_BUILT_FIELD_REQUEST, POST_CLIENT_PURPOSE_BUILT_FIELD_SUCCESS, POST_CLIENT_PURPOSE_BUILT_FIELD_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/customFields/purposeBuiltField',
      method: 'POST'
    }
  };
};

export const postPurposeBuiltFieldTemplate = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_PURPOSE_BUILT_FIELD_TEMPLATE_REQUEST,
        POST_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
        POST_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE
      ],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/purposeBuiltFieldTemplate',
      method: 'POST'
    }
  };
};

export const updateClientCustomField = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_CUSTOM_FIELD_REQUEST, UPDATE_CLIENT_CUSTOM_FIELD_SUCCESS, UPDATE_CLIENT_CUSTOM_FIELD_FAILURE],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/customFields',
      method: 'PUT'
    }
  };
};

export const updatePurposeBuiltFieldTemplate = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_REQUEST,
        UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
        UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE
      ],
      authenticated: true,
      payload: values,
      endpoint: 'api/Client/purposeBuiltFieldTemplate',
      method: 'PUT'
    }
  };
};

export const deleteCustomField = clientCustomFieldId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_CUSTOM_FIELD_REQUEST, DELETE_CLIENT_CUSTOM_FIELD_SUCCESS, DELETE_CLIENT_CUSTOM_FIELD_FAILURE],
      authenticated: true,
      endpoint: `api/Client/customFields/${clientCustomFieldId}`,
      method: 'DELETE'
    }
  };
};

export const deletePurposeBuiltField = clientCustomFieldId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_CLIENT_PURPOSE_BUILT_FIELD_REQUEST,
        DELETE_CLIENT_PURPOSE_BUILT_FIELD_SUCCESS,
        DELETE_CLIENT_PURPOSE_BUILT_FIELD_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/customFields/purposeBuiltField/${clientCustomFieldId}`,
      method: 'DELETE'
    }
  };
};

export const deletePurposeBuiltFieldTemplate = purposeBuiltFieldTemplateId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_REQUEST,
        DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_SUCCESS,
        DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/purposeBuiltFieldTemplate/${purposeBuiltFieldTemplateId}`,
      method: 'DELETE'
    }
  };
};

// END REGION \\

export const getInternalUsers = () => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_INTERNAL_USERS_REQUEST, GET_INTERNAL_USERS_SUCCESS, GET_INTERNAL_USERS_FAILURE],
      authenticated: true,
      endpoint: 'users/basicUsersInfo',
      method: 'GET'
    }
  };
};

export const getClientCalendars = (clientId, year) => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_CALENDARS_REQUEST, GET_CLIENT_CALENDARS_SUCCESS, GET_CLIENT_CALENDARS_FAILURE],
      authenticated: true,
      endpoint: `clientPayroll/calendars/${clientId}/${year}`,
      method: 'GET'
    }
  };
};

export const getCalendarPeriods = calendarId => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CALENDAR_PERIODS_REQUEST, GET_CALENDAR_PERIODS_SUCCESS, GET_CALENDAR_PERIODS_FAILURE],
      authenticated: true,
      endpoint: `clientPayroll/calendars/${calendarId}`,
      method: 'GET'
    }
  };
};

export const postClientCalendar = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_CLIENT_CALENDAR_REQUEST, POST_CLIENT_CALENDAR_SUCCESS, POST_CLIENT_CALENDAR_FAILURE],
      authenticated: true,
      endpoint: 'clientPayroll/calendars',
      method: 'POST',
      payload: values
    }
  };
};

export const updateClientCalendar = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_CALENDAR_REQUEST, UPDATE_CLIENT_CALENDAR_SUCCESS, UPDATE_CLIENT_CALENDAR_FAILURE],
      authenticated: true,
      endpoint: 'clientPayroll/calendars',
      method: 'PUT',
      payload: values
    }
  };
};

export const updatePeriod = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_PERIOD_REQUEST, UPDATE_PERIOD_SUCCESS, UPDATE_PERIOD_FAILURE],
      authenticated: true,
      endpoint: 'clientPayroll/calendars/periods',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteClientCalendar = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_CALENDAR_REQUEST, DELETE_CALENDAR_SUCCESS, DELETE_CALENDAR_FAILURE],
      authenticated: true,
      endpoint: `clientPayroll/calendars/${id}`,
      method: 'DELETE'
    }
  };
};

export const getClientPolicyNotes = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_POLICY_NOTES_REQUEST, GET_CLIENT_POLICY_NOTES_SUCCESS, GET_CLIENT_POLICY_NOTES_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/policynotes`,
      method: 'GET'
    }
  };
};

export const postClientPolicyNotes = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_CLIENT_POLICY_NOTES_REQUEST, POST_CLIENT_POLICY_NOTES_SUCCESS, POST_CLIENT_POLICY_NOTES_FAILURE],
      authenticated: true,
      endpoint: 'clients/policynotes',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientPolicyNotes = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_CLIENT_POLICY_NOTES_REQUEST, DELETE_CLIENT_POLICY_NOTES_SUCCESS, DELETE_CLIENT_POLICY_NOTES_FAILURE],
      authenticated: true,
      endpoint: `clients/policynotes/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientPolicyNotes = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_POLICY_NOTES_REQUEST, UPDATE_CLIENT_POLICY_NOTES_SUCCESS, UPDATE_CLIENT_POLICY_NOTES_FAILURE],
      authenticated: true,
      endpoint: 'clients/policynotes',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientHomesaleGeneralInfo = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_HOMESALE_INFO_REQUEST, GET_CLIENT_HOMESALE_INFO_SUCCESS, GET_CLIENT_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/homeSaleGeneralInfo`,
      method: 'GET'
    }
  };
};

export const updateClientHomesaleGeneralInfo = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_HOMESALE_INFO_REQUEST, UPDATE_CLIENT_HOMESALE_INFO_SUCCESS, UPDATE_CLIENT_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: 'clients/homeSaleGeneralInfo',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientLumpSum = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_LUMP_SUM_REQUEST, GET_CLIENT_LUMP_SUM_SUCCESS, GET_CLIENT_LUMP_SUM_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/getClientLumpSum`,
      method: 'GET'
    }
  };
};

export const updateClientLumpSum = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_LUMP_SUM_REQUEST, UPDATE_CLIENT_LUMP_SUM_SUCCESS, UPDATE_CLIENT_LUMP_SUM_FAILURE],
      authenticated: true,
      endpoint: 'clients/updateClientLumpSum',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientContacts = clientRecordId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_CONTACTS_REQUEST, GET_CLIENT_CONTACTS_SUCCESS, GET_CLIENT_CONTACTS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/contacts/${clientRecordId}`,
      method: 'GET'
    }
  };
};

export const getClientContract = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_CONTRACT_REQUEST, GET_CLIENT_CONTRACT_SUCCESS, GET_CLIENT_CONTRACT_FAILURE],
      authenticated: true,
      endpoint: `clientcontracts/${id}`,
      method: 'GET'
    }
  };
};

export const postClientContact = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_CONTACT_REQUEST, POST_CLIENT_CONTACT_SUCCESS, POST_CLIENT_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/contacts',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientContact = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_CONTACT_REQUEST, DELETE_CLIENT_CONTACT_SUCCESS, DELETE_CLIENT_CONTACT_FAILURE],
      authenticated: true,
      endpoint: `api/Client/contacts/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientContact = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_CONTACT_REQUEST, UPDATE_CLIENT_CONTACT_SUCCESS, UPDATE_CLIENT_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/contacts',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientIssuesAndChallenges = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_ISSUES_CHALLENGES_REQUEST, GET_CLIENT_ISSUES_CHALLENGES_SUCCESS, GET_CLIENT_ISSUES_CHALLENGES_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/issuesandchallenges`,
      method: 'GET'
    }
  };
};

export const postClientIssuesAndChallenges = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_CLIENT_ISSUES_CHALLENGES_REQUEST, POST_CLIENT_ISSUES_CHALLENGES_SUCCESS, POST_CLIENT_ISSUES_CHALLENGES_FAILURE],
      authenticated: true,
      endpoint: 'clients/issuesandchallenges',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientIssuesAndChallenges = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_CLIENT_ISSUES_CHALLENGES_REQUEST, DELETE_CLIENT_ISSUES_CHALLENGES_SUCCESS, DELETE_CLIENT_ISSUES_CHALLENGES_FAILURE],
      authenticated: true,
      endpoint: `clients/issuesandchallenges/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientIssuesAndChallenges = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_ISSUES_CHALLENGES_REQUEST, UPDATE_CLIENT_ISSUES_CHALLENGES_SUCCESS, UPDATE_CLIENT_ISSUES_CHALLENGES_FAILURE],
      authenticated: true,
      endpoint: 'clients/issuesandchallenges',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientGeneralNotes = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_GENERAL_NOTES_REQUEST, GET_CLIENT_GENERAL_NOTES_SUCCESS, GET_CLIENT_GENERAL_NOTES_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/generalnotes`,
      method: 'GET'
    }
  };
};

export const postClientGeneralNotes = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_CLIENT_GENERAL_NOTES_REQUEST, POST_CLIENT_GENERAL_NOTES_SUCCESS, POST_CLIENT_GENERAL_NOTES_FAILURE],
      authenticated: true,
      endpoint: 'clients/generalnotes',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientGeneralNotes = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_CLIENT_GENERAL_NOTES_REQUEST, DELETE_CLIENT_GENERAL_NOTES_SUCCESS, DELETE_CLIENT_GENERAL_NOTES_FAILURE],
      authenticated: true,
      endpoint: `clients/generalnotes/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientGeneralNotes = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_GENERAL_NOTES_REQUEST, UPDATE_CLIENT_GENERAL_NOTES_SUCCESS, UPDATE_CLIENT_GENERAL_NOTES_FAILURE],
      authenticated: true,
      endpoint: 'clients/generalnotes',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientContractSLA = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_CONTRACT_SLA_REQUEST, GET_CLIENT_CONTRACT_SLA_SUCCESS, GET_CLIENT_CONTRACT_SLA_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${id}/SLA`,
      method: 'GET'
    }
  };
};

export const postClientContractSLA = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_CONTRACT_SLA_REQUEST, POST_CLIENT_CONTRACT_SLA_SUCCESS, POST_CLIENT_CONTRACT_SLA_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/SLA',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientContractSLA = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CLIENT_CONTRACT_SLA_REQUEST, DELETE_CLIENT_CONTRACT_SLA_SUCCESS, DELETE_CLIENT_CONTRACT_SLA_FAILURE],
      authenticated: true,
      endpoint: `api/Client/SLA/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientContractSLA = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CLIENT_CONTRACT_SLA_REQUEST, UPDATE_CLIENT_CONTRACT_SLA_SUCCESS, UPDATE_CLIENT_CONTRACT_SLA_FAILURE],
      authenticated: true,
      endpoint: 'api/Client/SLA',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientContractFees = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_CONTRACT_FEE_REQUEST, GET_CLIENT_CONTRACT_FEE_SUCCESS, GET_CLIENT_CONTRACT_FEE_FAILURE],
      authenticated: true,
      endpoint: `clientcontracts/${id}/fee`,
      method: 'GET',
      context: { clientId: id }
    }
  };
};

export const postClientContractFees = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_CLIENT_CONTRACT_FEE_REQUEST, POST_CLIENT_CONTRACT_FEE_SUCCESS, POST_CLIENT_CONTRACT_FEE_FAILURE],
      authenticated: true,
      endpoint: 'clientcontracts/fee',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientContractFees = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_CLIENT_CONTRACT_FEE_REQUEST, DELETE_CLIENT_CONTRACT_FEE_SUCCESS, DELETE_CLIENT_CONTRACT_FEE_FAILURE],
      authenticated: true,
      endpoint: `clientcontracts/fee/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientContractFees = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_CLIENT_CONTRACT_FEE_REQUEST, UPDATE_CLIENT_CONTRACT_FEE_SUCCESS, UPDATE_CLIENT_CONTRACT_FEE_FAILURE],
      authenticated: true,
      endpoint: 'clientcontracts/fee',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientContractsCreditsAndRebates = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
        GET_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
        GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/${id}/creditRebates`,
      method: 'GET'
    }
  };
};

export const postClientContractsCreditsAndRebates = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
        POST_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
        POST_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE
      ],
      authenticated: true,
      endpoint: 'api/Client/creditRebates',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientContractsCreditsAndRebates = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
        DELETE_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
        DELETE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/Client/creditRebates/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateClientContractsCreditsAndRebates = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_REQUEST,
        UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_SUCCESS,
        UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE
      ],
      authenticated: true,
      endpoint: 'api/Client/creditRebates',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientSpecialProcesses = clientId => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_SPECIAL_PROCESS_REQUEST, GET_CLIENT_SPECIAL_PROCESS_SUCCESS, GET_CLIENT_SPECIAL_PROCESS_FAILURE],
      authenticated: true,
      endpoint: `ClientSpecialProcesses/getall?clientId=${clientId}`,
      method: 'GET'
    }
  };
};

export const getClientSpecialProcessCategoryTypes = () => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_REQUEST,
        GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_SUCCESS,
        GET_CLIENT_SPECIAL_PROCESS_CATEGORIES_FAILURE
      ],
      authenticated: true,
      endpoint: 'ClientSpecialProcesses/GetSpecialProcessCategories',
      method: 'GET'
    }
  };
};

export const upsertClientSpecialProcess = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPSERT_CLIENT_SPECIAL_PROCESS_REQUEST, UPSERT_CLIENT_SPECIAL_PROCESS_SUCCESS, UPSERT_CLIENT_SPECIAL_PROCESS_FAILURE],
      authenticated: true,
      endpoint: 'ClientSpecialProcesses/Upsert',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientSpecialProcess = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_CLIENT_SPECIAL_PROCESS_REQUEST, DELETE_CLIENT_SPECIAL_PROCESS_SUCCESS, DELETE_CLIENT_SPECIAL_PROCESS_FAILURE],
      authenticated: true,
      endpoint: 'ClientSpecialProcesses/Delete',
      method: 'DELETE',
      payload: values
    }
  };
};

export const getClientPoliciesImportantNotes = clientId => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        GET_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
        GET_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
        GET_CLIENT_POLICIES_IMPORTANT_NOTES_FAILURE
      ],
      authenticated: true,
      endpoint: `ClientPolicies/ImportantNotes?clientId=${clientId}`,
      method: 'GET'
    }
  };
};
export const upsertClientPoliciesImportantNotes = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        UPSERT_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
        UPSERT_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
        UPSERT_CLIENT_POLICIES_IMPORTANT_NOTES_FAILURE
      ],
      authenticated: true,
      endpoint: 'ClientPolicies/ImportantNotes/Upsert',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteClientPoliciesImportantNotes = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        DELETE_CLIENT_POLICIES_IMPORTANT_NOTES_REQUEST,
        DELETE_CLIENT_POLICIES_IMPORTANT_NOTES_SUCCESS,
        DELETE_CLIENT_POLICIES_IMPORTANT_NOTES_FAILURE
      ],
      authenticated: true,
      endpoint: 'ClientPolicies/ImportantNotes/Delete',
      method: 'DELETE',
      payload: values
    }
  };
};

/* Home Sale Eligible Properties Requests */
export const getHomesaleEligibleProperties = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST, GET_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS, GET_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/eligibleProperties`,
      method: 'GET'
    }
  };
};

export const postHomesaleEligibleProperties = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        POST_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
        POST_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
        POST_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE
      ],
      authenticated: true,
      endpoint: 'clients/eligibleProperties',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteHomesaleEligibleProperties = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        DELETE_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
        DELETE_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
        DELETE_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE
      ],
      authenticated: true,
      endpoint: `clients/eligibleProperties/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateHomesaleEligibleProperties = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [
        UPDATE_HOMESALE_ELIGIBLE_PROPERTIES_REQUEST,
        UPDATE_HOMESALE_ELIGIBLE_PROPERTIES_SUCCESS,
        UPDATE_HOMESALE_ELIGIBLE_PROPERTIES_FAILURE
      ],
      authenticated: true,
      endpoint: 'clients/eligibleProperties',
      method: 'PUT',
      payload: values
    }
  };
};

/* Home Sale Clos Requests */
export const getHomesaleClosingCosts = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_HOMESALE_CLOSING_COSTS_REQUEST, GET_HOMESALE_CLOSING_COSTS_SUCCESS, GET_HOMESALE_CLOSING_COSTS_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/closingCosts`,
      method: 'GET'
    }
  };
};

export const postHomesaleClosingCosts = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_HOMESALE_CLOSING_COSTS_REQUEST, POST_HOMESALE_CLOSING_COSTS_SUCCESS, POST_HOMESALE_CLOSING_COSTS_FAILURE],
      authenticated: true,
      endpoint: 'clients/closingCosts',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteHomesaleClosingCosts = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_HOMESALE_CLOSING_COSTS_REQUEST, DELETE_HOMESALE_CLOSING_COSTS_SUCCESS, DELETE_HOMESALE_CLOSING_COSTS_FAILURE],
      authenticated: true,
      endpoint: `clients/closingCosts/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateHomesaleClosingCosts = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_HOMESALE_CLOSING_COSTS_REQUEST, UPDATE_HOMESALE_CLOSING_COSTS_SUCCESS, UPDATE_HOMESALE_CLOSING_COSTS_FAILURE],
      authenticated: true,
      endpoint: 'clients/closingCosts',
      method: 'PUT',
      payload: values
    }
  };
};

/* Home Sale GBO Inspections Requests */
export const getHomesaleGboInspections = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_HOMESALE_GBO_INSPECTIONS_REQUEST, GET_HOMESALE_GBO_INSPECTIONS_SUCCESS, GET_HOMESALE_GBO_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/gboInspections`,
      method: 'GET'
    }
  };
};

export const postHomesaleGboInspections = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_HOMESALE_GBO_INSPECTIONS_REQUEST, POST_HOMESALE_GBO_INSPECTIONS_SUCCESS, POST_HOMESALE_GBO_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: 'clients/gboInspections',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteHomesaleGboInspections = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_HOMESALE_GBO_INSPECTIONS_REQUEST, DELETE_HOMESALE_GBO_INSPECTIONS_SUCCESS, DELETE_HOMESALE_GBO_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `clients/gboInspections/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateHomesaleGboInspections = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_HOMESALE_GBO_INSPECTIONS_REQUEST, UPDATE_HOMESALE_GBO_INSPECTIONS_SUCCESS, UPDATE_HOMESALE_GBO_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: 'clients/gboInspections',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientPoliciesGeneralInfo = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_POLICIES_GENERAL_INFO_REQUEST, GET_POLICIES_GENERAL_INFO__SUCCESS, GET_POLICIES_GENERAL_INFO__FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/policiesGeneral`,
      method: 'GET'
    }
  };
};

export const updateClientPoliciesGeneralInfo = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_POLICIES_GENERAL_INFO__REQUEST, UPDATE_POLICIES_GENERAL_INFO__SUCCESS, UPDATE_POLICIES_GENERAL_INFO__FAILURE],
      authenticated: true,
      endpoint: 'clients/policiesGeneral',
      method: 'PUT',
      payload: values
    }
  };
};

export const getClientMetadata = () => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_CLIENT_METADATA_REQUEST, GET_CLIENT_METADATA_SUCCESS, GET_CLIENT_METADATA_FAILURE],
      authenticated: true,
      endpoint: 'clients/metadata',
      method: 'GET'
    }
  };
};

export const initializeGboInspections = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_GBO_INSPECTIONS_INITIALIZE_REQUEST, POST_GBO_INSPECTIONS_INITIALIZE_SUCCESS, POST_GBO_INSPECTIONS_INITIALIZE_FAILURE],
      authenticated: true,
      endpoint: `clients/gboInspections/initialize/${id}`,
      method: 'POST'
    }
  };
};

/* Home Sale HHG Processes Requests */
export const getHomesaleHHGProcesses = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_HOMESALE_HHG_PROCESS_REQUEST, GET_HOMESALE_HHG_PROCESS_SUCCESS, GET_HOMESALE_HHG_PROCESS_FAILURE],
      authenticated: true,
      endpoint: `clients/${id}/hhgProcesses`,
      method: 'GET'
    }
  };
};

export const postHomesaleHHGProcess = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [POST_HOMESALE_HHG_PROCESS_REQUEST, POST_HOMESALE_HHG_PROCESS_SUCCESS, POST_HOMESALE_HHG_PROCESS_FAILURE],
      authenticated: true,
      endpoint: 'clients/hhgProcesses',
      method: 'POST',
      payload: values
    }
  };
};

export const deleteHomesaleHHGProcess = id => {
  return {
    [CALL_INTAKE_API]: {
      types: [DELETE_HOMESALE_HHG_PROCESS_REQUEST, DELETE_HOMESALE_HHG_PROCESS_SUCCESS, DELETE_HOMESALE_HHG_PROCESS_FAILURE],
      authenticated: true,
      endpoint: `clients/hhgProcesses/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateHomesaleHHGProcess = values => {
  return {
    [CALL_INTAKE_API]: {
      types: [UPDATE_HOMESALE_HHG_PROCESS_REQUEST, UPDATE_HOMESALE_HHG_PROCESS_SUCCESS, UPDATE_HOMESALE_HHG_PROCESS_FAILURE],
      authenticated: true,
      endpoint: 'clients/hhgProcesses',
      method: 'PUT',
      payload: values
    }
  };
};

export const setLoadingComplete = () => ({
  type: SET_LOADING_COMPLETE
});

export const fetchClientPreferredVendors = clientId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CLIENT_PREFERRED_VENDORS_REQUEST, GET_CLIENT_PREFERRED_VENDORS_SUCCESS, GET_CLIENT_PREFERRED_VENDORS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${clientId}/preferredVendors`,
      method: 'GET'
    }
  };
};

export const upsertClientPreferredVendor = (clientId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPSERT_CLIENT_PREFERRED_VENDORS_REQUEST, UPSERT_CLIENT_PREFERRED_VENDORS_SUCCESS, UPSERT_CLIENT_PREFERRED_VENDORS_FAILURE],
      authenticated: true,
      endpoint: `api/Client/${clientId}/preferredVendors`,
      method: 'POST',
      payload: values
    }
  };
};

export const getMultiClientUsers = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_MULTI_CLIENT_USERS_REQUEST, GET_MULTI_CLIENT_USERS_SUCCESS, GET_MULTI_CLIENT_USERS_FAILURE],
    authenticated: true,
    endpoint: 'api/admin/internalClientUsers',
    method: 'GET'
  }
});

export const createMultiClientUser = email => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_MULTI_CLIENT_USER_REQUEST, POST_MULTI_CLIENT_USER_SUCCESS, POST_MULTI_CLIENT_USER_FAILURE],
    authenticated: true,
    endpoint: 'api/admin/internalClientUsers',
    method: 'POST',
    payload: {
      email
    }
  }
});

export const updateMultiClientUserAccess = (internalMultiClientUserId, hasAccessRevoked) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_MULTI_CLIENT_USER_ACCESS_REQUEST, UPDATE_MULTI_CLIENT_USER_ACCESS_SUCCESS, UPDATE_MULTI_CLIENT_USER_ACCESS_FAILURE],
    authenticated: true,
    endpoint: `api/admin/internalClientUsers/${internalMultiClientUserId}/access`,
    method: 'PUT',
    payload: {
      hasAccessRevoked
    }
  }
});

export const deleteMultiClientUser = internalMultiClientUserId => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_MULTI_CLIENT_USER_REQUEST, DELETE_MULTI_CLIENT_USER_SUCCESS, DELETE_MULTI_CLIENT_USER_FAILURE],
    authenticated: true,
    endpoint: `api/admin/internalClientUsers/${internalMultiClientUserId}`,
    method: 'DELETE'
  }
});

export const getAcumaticaClientRequestPreview = clientRecordId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACUMATICA_CLIENT_REQUEST_PREVIEW_REQUEST, GET_ACUMATICA_CLIENT_REQUEST_PREVIEW_SUCCESS, GET_ACUMATICA_CLIENT_REQUEST_PREVIEW_FAILURE],
      authenticated: true,
      endpoint: `api/client/${clientRecordId}/acumatica/previewPush`,
      method: 'GET'
    }
  };
};

export const getAcumaticaPushClientChanges = (clientRecordId, screenShotId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACUMATICA_PUSH_CLIENT_CHANGES_REQUEST, GET_ACUMATICA_PUSH_CLIENT_CHANGES_SUCCESS, GET_ACUMATICA_PUSH_CLIENT_CHANGES_FAILURE],
      authenticated: true,
      endpoint: `api/client/${clientRecordId}/acumatica/push/${screenShotId}`,
      method: 'GET'
    }
  };
};